import { render, staticRenderFns } from "./project-charts.vue?vue&type=template&id=2456304a"
import script from "./project-charts.vue?vue&type=script&lang=js"
export * from "./project-charts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports